<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 10L12 12C12 13.6569 10.6569 15 9 15L4 15C2.34315 15 1 13.6569 1 12L1 7C1 5.34314 2.34315 4 4 4L6 4"
        stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path
        d="M10.5 1C9.94772 1 9.5 1.44772 9.5 2C9.5 2.55228 9.94772 3 10.5 3L10.5 1ZM14 2L15 2C15 1.44771 14.5523 1 14 1L14 2ZM13 6C13 6.55229 13.4477 7 14 7C14.5523 7 15 6.55228 15 6L13 6ZM10.5 3L14 3L14 1L10.5 1L10.5 3ZM13 2L13 6L15 6L15 2L13 2Z"
        fill="var(--icon-color)" />
    <path d="M6 10L13.5 2.5" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
</svg>

